import { CricketResultId } from '@collector/sportsapi-client-legacy'

import { ResultIdsSet } from '../../ParticipantsDataTable/ResultIdsSet'
import { StatIdsSet } from '../../ParticipantsDataTable/StatIdsSet'
import { VerifyResultsSportFactory } from './VerifyResultsSportFactory'

export function verifyResultsCricketFactory(): VerifyResultsSportFactory {
  function getResultsIdsSet(): ResultIdsSet {
    return new ResultIdsSet([
      CricketResultId.FirstInningRuns,
      CricketResultId.Wickets,
      CricketResultId.Overs,
      CricketResultId.CurrentBall,
    ])
  }

  function getDisabledResultsIdsSet(): ResultIdsSet {
    return new ResultIdsSet([
      CricketResultId.FirstInningRuns,
      CricketResultId.Wickets,
    ])
  }

  function getStatIdsSet(): StatIdsSet {
    return new StatIdsSet([])
  }

  return {
    getResultsIdsSet,
    getDisabledResultsIdsSet,
    getStatIdsSet,
  }
}
